import React, { memo } from 'react';
import { OfferList } from './OfferList';
import { Button, HasAccess, Row } from 'components';
import { RejectModal } from './modals/RejectModal';
import { useOfferActions } from './useOfferActions';
import { NegotiateModal } from './modals/NegotiateModal';
import { useRejectOffer } from './modals/useRejectOffer';
import { useCommercialOffers } from './useCommercialOffers';
import { useNegotiateOffer } from './modals/useNegotiateOffer';
import { CommercialOfferNegotiationReasons, CommercialOfferRejectionReasons } from 'models/CommercialOffer';
import styles from './styles.module.scss';
import { PERMISSIONS } from 'constants/permissions';
import { PlusIcon } from 'components/common/icons';
import { AddCommercialOfferModal } from 'feature/dealTabs/commercialOffers/addCommercialOffer';

export const DealCommercialOffers: React.FC = memo(() => {
  const {
    id,
    offers,
    rejectForm,
    negotiateForm,
    isLoadingOffer,
    isFinalStatus,
    addCommercialOfferState,
    handleError,
    handleSuccess,
    handleViewOffer,
    handleCreateCopy,
    handleCreateOffer,
    handleCancelOffer,
    handleDeleteOffer,
  } = useCommercialOffers();

  const {
    offerToReject,
    setOfferToReject,
    isLoadingReject,
    handleReject,
    closeModal: closeRejectModal,
  } = useRejectOffer(rejectForm, handleSuccess, handleError);

  const {
    offerToNegotiate,
    setOfferToNegotiate,
    isLoadingNegotiate,
    handleNegotiate,
    closeModal: closeNegotiateModal,
  } = useNegotiateOffer(negotiateForm, handleSuccess, handleError);

  const { handleAction } = useOfferActions(id || '', setOfferToReject, setOfferToNegotiate, handleSuccess);

  const closeModal = () => {
    closeRejectModal();
    closeNegotiateModal();
  };

  return (
    <div className={styles.container}>
      <Row justify="end" className={'margin-b-20'}>
        {!isFinalStatus && (
          <HasAccess role={PERMISSIONS.deals.commercialOffers.write}>
            <Button type={'primary'} onClick={handleCreateOffer} icon={<PlusIcon color={'#FFFFFF'} />}>
              Add New
            </Button>
          </HasAccess>
        )}
      </Row>
      <div className={styles.content}>
        <OfferList
          offers={offers}
          isLoading={isLoadingOffer}
          onDelete={handleDeleteOffer}
          onView={handleViewOffer}
          onAction={handleAction}
          onCreateCopy={handleCreateCopy}
        />
      </div>
      <AddCommercialOfferModal modalState={addCommercialOfferState} onModalStateChange={handleCancelOffer} id={id} />
      <RejectModal
        form={rejectForm}
        loading={isLoadingReject}
        open={!!offerToReject}
        onSubmit={handleReject}
        onCancel={closeModal}
        rejectionReasons={Object.values(CommercialOfferRejectionReasons)}
      />
      <NegotiateModal
        form={negotiateForm}
        loading={isLoadingNegotiate}
        open={!!offerToNegotiate}
        onSubmit={handleNegotiate}
        onCancel={closeModal}
        rejectionReasons={Object.values(CommercialOfferNegotiationReasons)}
      />
    </div>
  );
});
